/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import Input from "components/Input";

export default function ControlledInput({
    control,
    name,
    handleChange,
    label,
    rules,
    error,
    defaultValue,
    ...props
}) {
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            rules={rules}
            render={({ field }) => (
                <>
                    <Input
                        label={label}
                        error={error}
                        {...props}
                        {...field}
                    />
                </>
            )}
        ></Controller>
    );
}
